import * as React from "react";
import {useState, useEffect} from "react";
import {RouteComponentProps} from "react-router-dom";
import {TextField, Otp, Button} from "web-com";
import {requestOtp, validateOtp} from "profile/api";
import {COLOR, INPUT_TYPE, StyleType} from "utils/variables";
import ContainerBox from "myshubhlife-component/container-box";
import {FIELD_NAMES} from "profile/enums";
import {partnerOfferings} from "login/config";
import {logWebEngageEvent} from "analytics/eventApi";

interface IConnectProps {
    mobileNumber?: string;
    userId: number;
    onClose?: () => void;
    utm_source?: string;
}
const OTP_FAILED = "Something went wrong, Please try again later.";
enum LENGTH {
    OTP = 6,
    MOBILE = 10,
}
const RenderOtp = (props: IConnectProps & RouteComponentProps) => {
    const [otp, updateOtp] = useState<string[]>([]);
    const [mobileNumber, updateMobileNumber] = useState<string>(props.mobileNumber);
    const [errors, setErrors] = useState<string>(null);
    const [renderOtpField, setRenderOtpField] = useState({
        showOtpField: false,
        disableInput: false,
    });
    const handleOtpUpdate = async (newOtp: string[]) => {
        updateOtp([...newOtp]);
        setErrors(null);
        if (newOtp.join("").length === LENGTH.OTP) {
            try {
                const res = await validateOtp(mobileNumber, +newOtp.join(""));
                if (res.status === 200) {
                    logWebEngageEvent({
                        event_data: {SUCCESS: true},
                        event_name: "MobileNumberVerification",
                        user_id: props.userId,
                        type: "event",
                    }).finally(() => {
                        props.onClose(true);
                    });
                }
            } catch (error) {
                logWebEngageEvent({
                    event_data: {SUCCESS: false},
                    event_name: "MobileNumberVerification",
                    user_id: props.userId,
                    type: "event",
                }).finally(() => {
                    setErrors(error?.response?.data?.err || OTP_FAILED);
                });
            }
        }
    };
    const handleGenerateOtp = async () => {
        if (mobileNumber.length === LENGTH.MOBILE) {
            try {
                const res = await requestOtp(Number(mobileNumber));
                if (res.status === 200) {
                    setRenderOtpField({showOtpField: true, disableInput: true});
                }
            } catch (error) {
                setErrors(error);
            }
        }
    };
    return (
        <ContainerBox backgroundColor={COLOR.WHITE}>
            <TextField
                type={INPUT_TYPE.NUMBER}
                label={"Please enter mobile number"}
                placeholder={"Enter mobile number"}
                value={mobileNumber}
                fieldName={FIELD_NAMES.MOBILE}
                onChange={(type, value) => updateMobileNumber(value)}
                disabled={renderOtpField.disableInput}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            {
                renderOtpField.showOtpField &&
                <Otp
                    otp={otp}
                    otpLength={LENGTH.OTP}
                    otpType={INPUT_TYPE.NUMBER}
                    updateOtp={(newOtp) => handleOtpUpdate(newOtp)}
                    resendOtp={handleGenerateOtp}
                />
            }
            {errors && <p className="otp-error">{errors}</p>}
            {
                !renderOtpField.showOtpField && !renderOtpField.disableInput &&
                <Button
                    bgColor={partnerOfferings[props.utm_source]?.colors?.green}
                    buttonText="Send OTP"
                    onClick={handleGenerateOtp}
                    isDisabled={!mobileNumber || mobileNumber.length !== LENGTH.MOBILE || renderOtpField.disableInput}
                    width={200}
                    fontWeight={500}
                    height={45}
                />
            }
        </ContainerBox>
    );
};

export default RenderOtp;
